import {Injectable} from '@angular/core';
import {MessageModalComponent, SubscribeModalComponent} from '@shared/modals';
import {MessagePopup} from '@core/models';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

@Injectable({
  providedIn: 'any'
})
export class MessageService {

  constructor(private _matDialog: MatDialog) {
  }

  public openConfirmModal(data: MessagePopup): MatDialogRef<MessageModalComponent> {
    return this._matDialog.open(MessageModalComponent, {
      data,
      restoreFocus: false,
      autoFocus: false
    });
  }

  public openSubscribeModal(msg = 'Subscribe now to host events'): void {
    const data: MessagePopup = {
      msg,
      isConfirm: false
    };
    this._matDialog.open(SubscribeModalComponent, {data, restoreFocus: false, autoFocus: false});
  }

}
